import { FlexBox, Checkbox, Li, Span } from '@vp/swan';
import { useUserFeatureContext } from '@vp/core-ui-components';

interface DebugFeatureControlsProps {
  featureName: string;
  enabled: boolean;
}

export const DebugFeatureControls = ({
  featureName,
  enabled,
}: DebugFeatureControlsProps) => {
  const { overrideFeatureSettings: toggleFeature } = useUserFeatureContext();
  return (
    <Li>
      <FlexBox justifyContent="space-between" px={5}>
        <Span fontSize="small" mr={7}>
          {featureName}
        </Span>
        <Checkbox
          checked={enabled}
          onChange={() => toggleFeature({ featureName })}
        />
      </FlexBox>
    </Li>
  );
};
